export function isPhoneScreen({ width, height }) {
  return Math.min(width, height) < 600;
}

export function currentScreenIsPhone() {
  return isPhoneScreen(window.screen);
}
